import React, { useEffect, useState } from "react";
import { useForm, useStep } from "react-hooks-helper";
import { Names } from "./stepForm/Names";
import { Address } from "./stepForm/Address";
import { Contact } from "./stepForm/Contact";
import { Review } from "./stepForm/Review";
import { Submit } from "./stepForm/Submit";
import { WhatAreYouHopingToAchieve } from "./stepForm/WhatAreYouHopingToAchieve";
import { Buy } from "./stepForm/buy/Buy";
import { WhenAreYouLooking } from "./stepForm/refinance/WhenAreYouLooking";
import { PrimaryBorrower } from "./stepForm/refinance/PrimaryBorrower";
import { HowCanWeReachYou } from "./stepForm/HowCanWeReachYou";
import { WhereAreYouLooking } from "./stepForm/WhereAreYouLooking";
import { PropertyUse } from "./stepForm/PropertyUse";
import { EstimatedBudget } from "./stepForm/buy/EstimatedBudget";
import { DownPayment } from "./stepForm/buy/DownPayment";
import { LandStatus } from "./stepForm/LandStatus";

const defaultData = {
  primaryBorrowerFirstName: "",
  primaryBorrowerLastName: "",
  phone: "",
  city: "",
  state: "",
  whenAreYouLooking: "",
  propertyUse: "",
  downPayment: "",
  estimatedBudget: "",
  landStatus: "",
  // data coming from the iframe
};

const steps = [
  { id: "whereAreYouLooking" },
  { id: "whenAreYouLooking" },
  { id: "estimatedBudget" },
  { id: "downPayment" },
  { id: "propertyUse" },
  { id: "landStatus" },
  { id: "primaryBorrower" },
  { id: "howCanWeReachYou" },
];

export const MultiStepForm = () => {
  const [formData, setForm] = useForm(defaultData);
  const [extraData, setExtraData] = useState({
    builderName: "",
    pageSource: "",
    builderEmail: "",
    ownerId: "",
    applicationLink: "",
  });
  const { step, navigation } = useStep({
    steps,
    initialStep: 0,
  });

  console.log(formData);
  console.log(extraData);

  useEffect(() => {
    function onMessage(e) {
      // Add origin check for security
      if (e.origin !== window.location.origin) {
        console.log("Message from different origin, ignoring");
        return;
      }

      console.log("Received message:", e.data);
      const { builder, pageURL, builderEmail, ownerId, applicationLink } = e.data;

      console.log("message event listener triggered", { builder, pageURL, builderEmail, ownerId });

      // Update form data with received values
      if (builder || pageURL || builderEmail || ownerId) {
        setExtraData((prev) => ({
          ...prev,
          ...(builder && { builderName: builder }),
          ...(pageURL && { pageSource: pageURL }),
          ...(builderEmail && { builderEmail: builderEmail }),
          ...(ownerId && { ownerId: ownerId }),
          ...(applicationLink && { applicationLink: applicationLink }),
        }));
      }
    }

    window.addEventListener("message", onMessage);

    // Also send a ready message to parent to confirm iframe is loaded
    window.parent.postMessage({ type: "iframe-ready" }, "*");

    return () => window.removeEventListener("message", onMessage);
  }, []);

  const props = { formData, setForm, navigation, useStep, step, extraData };

  switch (step.id) {
    case "downPayment":
      return <DownPayment {...props} />;
    case "propertyUse":
      return <PropertyUse {...props} />;
    case "whereAreYouLooking":
      return <WhereAreYouLooking {...props} />;
    case "estimatedBudget":
      return <EstimatedBudget {...props} />;
    case "whatAreYouHopingToAchieve":
      return <WhatAreYouHopingToAchieve {...props} />;
    case "names":
      return <Names {...props} />;
    case "address":
      return <Address {...props} />;
    case "contact":
      return <Contact {...props} />;
    case "review":
      return <Review {...props} />;
    case "buy":
      return <Buy {...props} />;
    case "submit":
      return <Submit {...props} />;
    case "whenAreYouLooking":
      return <WhenAreYouLooking {...props} />;
    case "landStatus":
      return <LandStatus {...props} />;
    case "primaryBorrower":
      return <PrimaryBorrower {...props} />;
    case "howCanWeReachYou":
      return <HowCanWeReachYou {...props} />;
  }

  return (
    <div>
      <h1>CalCon Mutual Mortgage</h1>
    </div>
  );
};
